import { rollupLabel } from "../lib/projectTasksCopy";

// Sprint-017 E7 (design §3.7 / §2.2, ADR-003 §8) — the "{n} of {m} done"
// roll-up: the `.parent-badge` pill (pine-on-pine-soft, reused verbatim
// from the parent-assignment roll-up) + a thin progress bar. Same grammar
// in all three homes — the Projects list card (`pt-card-progress`), the
// overlay body top (`pt-rollup`), and (mirrored) the overlay header.
//
// A zero-task project shows NOTHING (no pill, no bar). Never shown to a
// de-identified assignee (that belongs only to people who can see the
// project). Read-time only — never auto-completes the project (Q4).

export interface ProjectRollupProps {
  done: number;
  total: number;
  /** `"body"` → `.pt-rollup` (overlay); `"card"` → `.pt-card-progress`
   * (list card). */
  variant?: "body" | "card";
}

export function ProjectRollup({ done, total, variant = "body" }: ProjectRollupProps) {
  if (total <= 0) return null;
  const pct = Math.round((done / total) * 100);
  const cls = variant === "card" ? "pt-card-progress" : "pt-rollup";
  return (
    <div class={cls}>
      <span class="parent-badge">{rollupLabel(done, total)}</span>
      <div
        class="parent-progress-track"
        role="progressbar"
        aria-valuenow={done}
        aria-valuemin={0}
        aria-valuemax={total}
        aria-label={rollupLabel(done, total)}
      >
        <div class="parent-progress-fill" style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}
